import { Activite } from './activite.model';
import { Cahier } from './cahier.model';
import { StatutHabilitation } from './statut-habilitation.model';
import { RefStatut } from './statut.ref.model';
import { DataIdConverterFactory } from 'src/app/core/services/mapper/data-id.converter';
import { ArrayClassConverterFactory } from '../../../core/services/mapper/data-property.converter';

export class Habilitation {
    static jsonMap = {
        id: { key: 'id', optional: true },
        cahier: { key: 'idCahier', converter: new (DataIdConverterFactory.build(Cahier, 'cahiers'))() },
        activite: { key: 'idActivite', converter: new (DataIdConverterFactory.build(Activite, 'activites'))() },
        statut: { key: 'idStatut', converter: new (DataIdConverterFactory.build(RefStatut, 'statutsHabilitation'))(), optional: true },
        historique: { key: 'historiquesStatut', converter: new (ArrayClassConverterFactory.build(StatutHabilitation))(), optional: true }
    };

    public id: number = undefined;
    public cahier: Cahier = undefined;
    public activite: Activite = undefined;
    public statut: RefStatut = undefined;
    public historique: StatutHabilitation[] = [];
}
